import React from 'react'
import { Checkbox } from 'react-icheck'
import yup from 'yup'
import Form from 'react-formal'
import NavigationBar from '../Commons/NavigationBar'
import ProfilePicture from '../Commons/ProfilePicture'
import RadioGroup from 'react-radio-group'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { hashHistory } from 'react-router'
import moment from 'moment'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import _ from 'lodash'
import MiddleLine from '../../img/icons/general-icons/separator_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

var userSchema = yup.object({
  id: yup.string(),
  tipoDocumento: yup.string().nullable().required('Seleccione el tipo de documento'),
  numeroDocumento: yup.string().min(4, 'El numero de identificación debe tener mínimo 4 caracteres').required('Ingrese el número de identificación'),
  nombres: yup.string().min(2, 'El nombre debe tener mínimo 2 caracteres').required('Ingrese el nombre completo'),
  apellidos: yup.string().min(2, 'El apellido debe tener mínimo 2 caracteres').required('Ingrese los apellidos'),
  telefono: yup.string().min(5, 'El número telefono debe tener mínimo 5 caracteres').required('Ingrese el número de télefono'),
  celular: yup.string().min(10, 'El número de celular debe tener mínimo 10 caracteres').required('Ingrese el número de celular'),
  email: yup.string().email('Ingrese un email valido').required('Ingrese el email'),
  password: yup.string().min(6, 'La contraseña debe tener mínimo 6 caracteres').required('Ingrese la contraseña'),
  rol: yup.string().min(6, 'La dirección debe tener mínimo 6 caracteres').required('Ingrese la dirección')
})

export default class UserForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ select: {},inputClass: 'form-input', selectedGender: 'f', file: '', imagePreviewUrl: '', model: {}, emailInfo: {}, userImage: '', dirty: false, isUpdate: this.props.isUpdate, userId: this.props.userId })
  }

  componentWillMount () {
    this.loadRoles()
    this.loadUserData()
  }

  imageUpload (event) {
    let picture = document.getElementById('photo')
    let reader = new FileReader()
    let file = event.target.files[0]
    let megas = (file.size / 1048576)
    if (megas > 2) {
      this.refs.container.error('Tamaño de la foto exede el limite permitido (2 Megabytes)', '', {
        closeButton: true
      })
    } else {
      picture.src = window.URL.createObjectURL(event.target.files[0])
      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        })
      }
      reader.readAsDataURL(file)
    }
  }
  toggleChangeActivo () {
    this.setState({
      activo: !this.state.activo
    })
  }
  uploadPicture (event) {
    let picture = document.getElementById('photo')
    picture.src = window.URL.createObjectURL(event.target.files[0])
  }

  chooseGender (changeEvent) {
    this.setState({ selectedGender: changeEvent.target.value })
  }

  searchRedirect () {
    hashHistory.push('searchUser')
  }

  cancelFunction (e) {
    e.preventDefault()
    if (this.state.dirty === true) {
      this.refs.container.warning(<span className='center-content'>Tiene cambios pendientes ¿Desea regresar al Listado de todos modos? <br /><br /><span className='email-validation-container'><button type='button' className='btn btn-confirm clear' onClick={this.searchRedirect.bind(this)}>Si</button><button type='button' className='btn btn-confirm clear'>No</button></span></span>, <em>Tiene cambios pendientes</em>, {
        closeButton: true,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': 0,
        'extendedTimeOut': 0,
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      })
    } else {
      this.searchRedirect()
    }
  }

  loadUserData () {
    if (this.state.userId) {
      let endpoint = `api/v1/user/numeroDocumento/${this.state.userId}`
      request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontraron usuarios', '', {
            closeButton: true
          })
        } else if (!_.isEmpty(res.body)) {
          this.setState({ activo: res.body.activo,model: res.body, selectedGender: res.body.genero, imagePreviewUrl: res.body.image, userImage: res.body.image, rol: res.body.rol[0] })
        }
      })
    }
  }
  loadRoles ()
  {
    let endpoint2 = 'api/v1/role'
    request
    .get(endpoint2)
    .set('Authorization', `Bearer ${getToken()}`)
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, respose) => {
      if (err) {
        this.refs.container.error('Algo inesperado ocurrió, al intentar cargar los roles del usuario', '', {
          closeButton: true
        })
      } else if (!_.isEmpty(respose.body)){
        this.setState({'select': respose.body})
      }
    })
  }
  handleOptionChangeRole (changeEvent) {
    // invalid-field
    this.setState({ rol: changeEvent.target.value})
  }
  saveUser (formValue) {
    let model = this.state.model
    model.genero = this.state.selectedGender
    model.image = this.state.imagePreviewUrl
    model.rol = this.state.rol
    model.activo = this.state.activo
    let endpoint = 'api/v1/user/'

    if (this.state.isUpdate === true) {
      request
      .put(endpoint)
      .use(NoCache)
      .set('Authorization', `Bearer ${getToken()}`)
      .send({user: model})
      .end((err, res) => {
        if (err || !res.ok) {
          this.refs.container.error('No se pudo Actualizar el paciente', '', {
            closeButton: true
          })
        } else {
          this.refs.container.success('El paciente se actualizó satisfactoriamente', '', {
            closeButton: true
          })
          setTimeout(() => { hashHistory.push('searchUser') }, 3000)
        }
      })
    } else {
      if (model.password === this.refs.confirm.value) {
        let endpoint = '/api/v1/user/register'
        request
        .post(endpoint)
        .use(NoCache)
        .set('Authorization', 'Bearer ' + getToken())
        .send({user: model})
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err || !res.ok) {
            this.refs.container.error('No se pudo registrar el paciente', '', {
              closeButton: true
            })
          } else {
            this.refs.container.success('El paciente se registró satisfactoriamente', '', {
              closeButton: true
            })
            setTimeout(() => { hashHistory.push('searchUser') }, 3000)
          }
        })
      } else if (model.password !== this.refs.confirm.value) {
        if (this.refs.confirm.value === '') {
          this.refs.container.error('Confirme la contraseña por favor', '', {
            closeButton: true
          })
          this.setState({ inputClass: 'form-input invalid-field' })
        } else {
          this.refs.container.error('Las contraseña no coinciden', '', {
            closeButton: true
          })
          this.setState({ inputClass: 'form-input invalid-field' })
        }
      }
    }
  }

  render () {
    var cOptions
    if (!_.isEmpty(this.state.select)) {
      let arrayElements = this.state.select
      cOptions = arrayElements.map(function (item, index) {
        return <option value={item._id}>{item.label}</option>
      })
    }
    return (
      <div className='main-information-container'>
        <NavigationBar dirty={this.state.dirty}/>
        <div className='registration-container-patient'>
          <div className='patient-profile'>
            <Form className='form-person-info' schema={userSchema} value={this.state.model} onChange={model => this.setState({ model, dirty: true })}>
              <ProfilePicture image={this.imageUpload.bind(this)} data={this.state.userImage}/>
              <div className='person-info-container'>
                <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
                <div className='person-data-fields person-left-container'>
                  <div className='flex'>
                    <div className='form-group'>
                      <Form.Field type='select' name='tipoDocumento' id='tipoDocumento' ref='tipoDocumento' className='select'>
                        <option value={null}>Documento</option>
                        <option value='CC'>CC</option>
                        <option value='CE'>CE</option>
                        <option value='PP'>PP</option>
                        <option value='TI'>TI</option>
                        <option value='RC'>RC</option>
                      </Form.Field>
                    </div>
                    <div className='form-group'>
                      <Form.Field name='numeroDocumento' id='numeroDocumento' ref='numeroDocumento' className='form-input form-input-id' placeholder='Número de Identificación'/>
                    </div>
                  </div>
                  <div className='form-group'>
                    <Form.Message className='message' for='tipoDocumento' />
                    <Form.Message className='message' for='numeroDocumento'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='nombres' id='nombres' ref='nombres' className='form-input' placeholder='Nombre Completo'/>
                    <Form.Message className='message' for='nombres'/>
                  </div>
                  <div className='form-group'>
                    <Form.Field name='apellidos' id='apellidos' className='form-input' ref='apellidos' placeholder='Apellidos'/>
                    <Form.Message className='message' for='apellidos'/>
                  </div>
                  <div className='form-group'>
                    <div className='gender-container'>
                      <input id='sex_f' ref='sex_f' name='gender' type='radio' value='f' className='register-switch-input' checked={this.state.selectedGender === 'f'} onChange={this.chooseGender.bind(this)} />
                      <label htmlFor='sex_f' className='register-switch-label'>Mujer</label>
                      <input id='sex_m' ref='sex_m' name='gender' type='radio' value='m' className='register-switch-input' checked={this.state.selectedGender === 'm'} onChange={this.chooseGender.bind(this)} />
                      <label htmlFor='sex_m' className='register-switch-label'>Hombre</label>
                    </div>
                  </div>
                  <div className='flex'>
                    <div className='form-group'>
                      <Form.Field name='telefono' id='telefono' className='form-input form-input-phone form-input-phone-left' ref='telefono' placeholder='Teléfono'/>
                    </div>
                    <div className='form-group'>
                      <Form.Field name='celular' id='celular' className='form-input form-input-phone' ref='celular' placeholder='Celular'/>
                    </div>
                  </div>
                  <div className='form-group'>
                    <Form.Message className='message' for='telefono' />
                    <Form.Message className='message' for='celular'/>
                  </div>
                </div>
                <img className='middleline middleline-patient' src={MiddleLine} />
                <div className='person-data-fields'>
                  <div className='form-group'>
                    <Form.Field name='email' id='email' className='form-input' ref='email' placeholder='Email' />
                    <Form.Message className='message' for='email'/>
                  </div>
                  {
                    (this.state.userId === '')
                    ? <div><div className='form-group'>
                        <Form.Field type='password' name='password' id='password' className={this.state.inputClass} ref='password' placeholder='Contraseña' />
                        <Form.Message className='message' for='contraseña'/>
                      </div>
                      <div className='form-group'>
                        <input type='password' name='confirm' id='confirm' className={this.state.inputClass} ref='confirm' placeholder='Confirmar contraseña' />
                      </div></div>
                    : ''
                  }
                  <div className='form-group'>
                    <select type='select' name='rol' id='entidad' ref='entidad'  value={this.state.rol} onChange={this.handleOptionChangeRole.bind(this)}>
                      <option value={''}>Ingrese un rol</option>
                      {cOptions}
                    </select>
                    <Form.Message className='message' for='rol'/>
                  </div>
                  <div className='form-group'>
                    <div className='check-input'>
                      <Checkbox ref='activo' checkboxClass='icheckbox_square-blue'checked={this.state.activo} onChange={this.toggleChangeActivo.bind(this)} increaseArea='16%' label='Activo'/>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-submit-btn-container'>
                 <button id='cancelSquares' className='form-submit-button save-button' onClick={this.cancelFunction.bind(this)}>⟵ Regresar</button>
                 <Form.Button type='submit' id='saveData' className='form-submit-button save-button' onClick={this.saveUser.bind(this)}>Guardar</Form.Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UserForm.js